import script from "./MaterialIcons.vue?vue&type=script&lang=ts&setup=true"
export * from "./MaterialIcons.vue?vue&type=script&lang=ts&setup=true"

import "./MaterialIcons.vue?vue&type=style&index=0&id=8ea0b08c&lang=scss&scoped=true"

import exportComponent from "/opt/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ea0b08c"]])

export default __exports__